//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GoogleMap from '@/components/Google/GoogleMap.vue';
import TimeSpan from '@/components/TimeSpan.vue';
//import { aFormModel } from 'ant-design-vue';

import { sysConfigs_stadiumConfig } from '@/apis/system'
import { venues_detail, venues_update, venues_add } from '@/apis/stadium'
import { area_list, oss_files } from '@/apis/config'
//import { fetchAll } from '@/apis/mch'

export default {
    components: {
        GoogleMap,
        TimeSpan
    },
    data() {
        let validateTimeRange = (rule, value, callback) => {
            try {
                if (!value) {
                    callback(new Error('請選擇營業時間'));
                    return;
                }

                const [startStr, endStr] = value.split('-');
                if (!startStr || !endStr) {
                    callback(new Error('請選擇完整的時間範圍'));
                    return;
                }
                const startMoment = this.$moment(startStr, 'HH:mm', true);
                const endMoment = this.$moment(endStr, 'HH:mm', true);
                if (!startMoment.isValid() || !endMoment.isValid()) {
                    callback(new Error('錯誤的時間格式'));
                    return;
                }
                if (startMoment.isSame(endMoment)) {
                    callback(new Error('開始時間和結束時間不能相同'));
                    return;
                }
                if (startMoment.isAfter(endMoment)) {
                    callback(new Error('結束時間必須晚於開始時間'));
                    return;
                }
                callback();
            } catch (error) {
                callback(error);
            }

        }

        //表單校驗
        const rules = {
            venueName: [{ required: true, message: '請輸入場館名稱！' }],
            //mchNo: [{ required: true, message: '請選擇所屬品牌！' }],
            sportTypeCode: [{ required: true, message: '請選擇運動類型！' }],
            areaCode: [{ required: true, message: '請選擇場所屬區域！' }],
            businessHours: [{ validator: validateTimeRange, trigger: 'change' }],
            address: [{ required: true, message: '請輸入場館地址！' }],
            contactPhone: [{ required: true, message: '請輸入場館電話！' }],
            venueInto: [{ required: true, message: '請輸入場館介紹！' }],
            features: [{ required: true, message: '請輸入場館特色！' }],
            status: [{ required: true, message: '請選擇場館狀態！' }],
        };

        const form = {
            mchNo: undefined,
            venueName: '',
            areaCode: '',
            venueImage: '',
            businessHours: '',
            address: '',
            longitude: 0,
            latitude: 0,
            contactPhone: '',
            promoVideo: '',
            features: '',
            usageRules: '',
            status: '',
            score: '',
            isPopular: false,
            isFeatured: false,

        };
        return {
            id: '',
            fileLoading: false,
            businessHours: '',
            //是否可修改場館名稱
            disabledVenueName: true,
            spinning: false,
            config: {
                //區域資訊
                areas: [],
                fetchs: []
            },
            form,
            rules,
            labelCol: { style: { width: '150px', }, },
            wrapperCol: { span: 14, },
            fileList: [],
            previewImage: undefined,
            previewVisible: false,
            googleMapShow: false,
            scoreDesc: ['1', '2', '3', '4', '5'],
        }
    },
    async mounted() {
        this.id = this.$route.params.id;
        if (this.id > 0) {
            this.disabledVenueName = !this.$access('ENT_VENUES_CHANGE_VENUENAME');
        } else {
            this.disabledVenueName = false;
        }
        this.spinning = true;
        await this.onPageConfig();
        if (this.id > 0) {
            await this.onPageLoad();
        }
        this.spinning = false;
    },
    methods: {
        // async getMchNoList() {
        //     try {
        //         const res = await fetchAll({ mchName: '', state: 1, pageSize: 9999, pageNumber: 1 }) || {};
        //         console.log(res);
        //         if (res.code == 0) {
        //             this.config.fetchs = res.data.records;
        //         } else {
        //             if (res.msg)
        //                 throw new Error(res.msg);
        //         }
        //     } catch (error) {
        //         this.$message.error(error.message);
        //     }
        // },
        async onPageConfig() {
            try {
                //await this.getMchNoList();
                this.config.provinces = await this.getAreaList();
            } catch (error) {
                console.log(error);
                this.$message.error(error.message);
            }
        },
        async onPageLoad() {
            try {
                const res = await venues_detail(this.id) || {};
                if (res.code == 0) {
                    const item = res.data || {};
                    const form = { ...this.form };
                    form.id = this.id;
                    form.venueName = item.venueName;
                    form.venueImage = item.venueImage;
                    form.address = item.address;
                    form.businessHours = item.businessHours;
                    form.contactPhone = item.contactPhone;
                    form.promoVideo = item.promoVideo;
                    form.areaCode = item.areaCode;
                    form.features = item.features;
                    form.usageRules = item.usageRules;
                    form.status = item.status + '';
                    form.longitude = item.longitude;
                    form.latitude = item.latitude;
                    form.mchNo = item.mchNo;
                    form.score = item.score;
                    form.isPopular = item.isPopular;
                    form.isFeatured = item.isFeatured;
                    this.form = form;
                    await this.onLoadFile();
                } else {
                    if (res.msg)
                        this.$message.error(res.msg);
                }
            } catch (error) {
                console.log(error);
                this.$message.error(error.message);
            }
        },
        async onLoadFile() {
            function getFileName(path) {
                const regex = /([^\/\\]+)$/;
                const match = regex.exec(path);
                if (match) {
                    return match[1];
                } else {
                    return null;
                }
            }
            const url = this.form.venueImage;
            if (url) {
                this.fileList = [{
                    uid: '-1',
                    name: getFileName(url),
                    status: 'done',
                    url: url
                }]
            }
        },
        async getAreaList() {
            try {
                const configOpenArea = await this.getStadiumConfig();
                this.config.areas = configOpenArea;
            } catch (error) {
                console.log(error);
                this.$message.error(error.message);
            }
        },
        async getStadiumConfig() {
            try {
                const res = await sysConfigs_stadiumConfig() || {};
                if (res.code == 0) {
                    const list = res.data || [];
                    const openAreaRes = list.filter(item => item.configKey == 'openArea');
                    if (openAreaRes.length > 0) {
                        try {
                            return JSON.parse(openAreaRes[0].configVal);
                        } catch (error) {
                            return openAreaRes[0].configVal;
                        }

                    } else {
                        return undefined;
                    }
                }
            } catch (error) {
                console.log(error);
                this.$message.error(error.message);
            }
        },
        //時段
        handleOnTimeSpanChange() {
            //用來清除異常提醒
            this.$refs.businessHoursItem.clearValidate();
        },

        //圖片上傳
        async handleFileChange({ fileList }) {
            console.log('handleFileChange', fileList);
            if (fileList.length > 0) {
                // 過濾掉非圖片文件
                const validFiles = fileList.filter(file =>
                    file.type?.startsWith('image/') ||
                    (file.originFileObj && file.originFileObj.type.startsWith('image/'))
                );
                try {
                    this.fileLoading = true;
                    const formData = new FormData();
                    formData.append('file', validFiles[0].originFileObj);
                    const res = await oss_files('ifBG', formData) || {};
                    if (res.code == 0) {
                        this.form.venueImage = res.data;
                        this.fileList = validFiles;
                    } else {
                        if (res.msg)
                            this.$message.error(error.message);
                    }
                } catch (error) {
                    console.log(error);
                    this.$message.error(error.message);
                } finally {
                    this.fileLoading = false;
                }
            } else {
                this.fileList = fileList;
            }

        },
        async handleFilePreview(file) {
            function getBase64(file) {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = error => reject(error);
                });
            }
            if (!file.url && !file.preview) {
                file.preview = await getBase64(file.originFileObj);
            }
            this.previewImage = file.url || file.preview;
            this.previewVisible = true;
        },
        handlePreviewCancel() {
            this.previewVisible = false;
        },

        handleOnFormValidate(e, v) {
            e.preventDefault();
            console.log('onFormValidate', v);
            this.$refs.form.validate(valid => {
                console.log(valid);
                if (valid) {
                    this.onSubmit();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        async onSubmit(e) {
            let formFunction;
            const form = { ...this.form };
            if (this.id > 0) {
                form.id = this.id;
                formFunction = venues_update;
            } else {
                formFunction = venues_add;
            }

            try {
                this.spinning = true;
                const res = await formFunction(form) || {};
                if (res.code == 0) {
                    this.$message.success('提交完成');
                    this.$router.push('/gymnasium');
                } else {
                    if (res.msg)
                        throw new Error(res.msg);
                }
            } catch (error) {
                console.log(error);
                this.$message.error(error.message);
            } finally {
                this.spinning = false;
            }
        },
        onLookMap() {
            this.googleMapShow = true;
        },
        handleMapCancel() {
            this.googleMapShow = false;
        },
        handleMapPositionChange(position) {
            this.form.longitude = position.lng;
            this.form.latitude = position.lat;
        }
    }
}
